import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import data from "../json/Footer/footer.json";
import { ReactComponent as Icon } from "../Icons/downarrow.svg";

const Footer = () => {
  const date = new Date();
  const [mobiletoggle, setMobileToggle] = useState(0);

  const year = date.getFullYear();
  const { pathname } = useLocation();

  let url = pathname.split("/");

  const mobtoggle = (id) => {
    if (mobiletoggle === id) {
      setMobileToggle(-1);
    } else {
      setMobileToggle(id);
    }
  };

  return (
    <div className="flex justify-center bg-greybg border-b-[8px] border-irisblue">
      <div className=" 2xl:container w-full flex justify-center flex-col">
        <div
          className={`px-6 md:px-10 lg:px-20  lg:px-20 py-12 lg:py-14  flex flex-col lg:flex-row w-full`}
        >
          <div className="w-full sm:w-8/12 md:w-6/12 lg:w-4/12 flex flex-col gap-6 text-primarycolor lg:mr-[5vw] xl:mr-[8vw]">
            <div className="">
              <div className="w-[45vw]  lg:w-[17.153vw]  justify-left flex items-center">
                <Link to={"/"}>
                  <img
                    src={process.env.PUBLIC_URL + "/images/transformalogo.svg"}
                    alt="Transforma_logo"
                  />
                </Link>
              </div>
            </div>
            <p className="text-16 text-primarycolor">
              To be a leading provider of content technology and services to STM
              research, learning, and content centric companies.
            </p>
            <div className="flex mt-2 md:mt-4 gap-3 ">
              <Link
                className="text-[#3A3A3F] hover:text-highlight"
                to="https://www.facebook.com/www.transforma.in"
                target="_"
              >
                {/* <img
                  src={process.env.PUBLIC_URL + "/images/Footer/facebook.svg"}
                  alt="facebook"
                /> */}
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="39"
                    height="39"
                    rx="19.5"
                    stroke="currentColor"
                  />
                  <path
                    d="M30 20C30 14.5 25.5 10 20 10C14.5 10 10 14.5 10 20C10 25 13.625 29.125 18.375 29.875V22.875H15.875V20H18.375V17.75C18.375 15.25 19.875 13.875 22.125 13.875C23.25 13.875 24.375 14.125 24.375 14.125V16.625H23.125C21.875 16.625 21.5 17.375 21.5 18.125V20H24.25L23.75 22.875H21.375V30C26.375 29.25 30 25 30 20Z"
                    fill="currentColor"
                  />
                </svg>
              </Link>
              <Link
                className="text-[#3A3A3F] hover:text-highlight"
                to="https://twitter.com/i/flow/login?redirect_after_login=%2Ftransformapress"
                target="_"
              >
                {/* <img
                  src={process.env.PUBLIC_URL + "/images/Footer/twitter.svg"}
                  alt="twitter"
                /> */}
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="39"
                    height="39"
                    rx="19.5"
                    stroke="currentColor"
                  />
                  <path
                    d="M21.5525 18.7251L27.6329 11.668H26.192L20.9125 17.7957L16.6956 11.668H11.832L18.2086 20.9341L11.832 28.3346H13.273L18.8485 21.8636L23.3017 28.3346H28.1654L21.5523 18.7251H21.5527H21.5525ZM19.5789 21.0156L18.9328 20.093L13.7922 12.751H16.0053L20.1539 18.6762L20.8 19.5988L26.1927 27.3007H23.9796L19.579 21.0159V21.0155L19.5789 21.0156Z"
                    fill="currentColor"
                  />
                </svg>
              </Link>
              <Link
                className="text-[#3A3A3F] hover:text-highlight"
                to="https://www.linkedin.com/company/transforma-private-limited"
                target="_"
              >
                {/* <img
                  src={process.env.PUBLIC_URL + "/images/Footer/linkedin.svg"}
                  alt="linkedin"
                /> */}
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="39"
                    height="39"
                    rx="19.5"
                    stroke="currentColor"
                  />
                  <path
                    d="M14.5 30H10.25V16.625H14.5V30ZM12.375 14.75C11 14.75 10 13.75 10 12.375C10 11 11.125 10 12.375 10C13.75 10 14.75 11 14.75 12.375C14.75 13.75 13.75 14.75 12.375 14.75ZM30 30H25.75V22.75C25.75 20.625 24.875 20 23.625 20C22.375 20 21.125 21 21.125 22.875V30H16.875V16.625H20.875V18.5C21.25 17.625 22.75 16.25 24.875 16.25C27.25 16.25 29.75 17.625 29.75 21.75V30H30Z"
                    fill="currentColor"
                  />
                </svg>
              </Link>
              {/* <Link>
                <img
                  src={process.env.PUBLIC_URL + "/images/Footer/skype.svg"}
                  alt="skype"
                />
              </Link> */}
            </div>
          </div>

          {/* desktop-view */}
          <div className=" grid grid-cols-2 md:grid  hidden lg:flex flex-col mt-10 lg:mt-0 gap-5 lg:flex-row lg:gap-14 w-full md:w-full justify-between">
            {data.map((section, idx) => (
              <div className="flex flex-col w-auto" key={idx}>
                <h1 className="text-18 font-semibold text-primarycolor">
                  {section.title}
                </h1>
                <div className="flex flex-col gap-2 lg:gap-3 mt-4 lg:mt-6 text-16">
                  {section.items.map((item, i) => (
                    <Link
                      to={item.path}
                      key={i}
                      target={item.target ? "_blank" : "_self"}
                    >
                      <p
                        className={`hover:text-highlight  ${
                          item.path === pathname
                            ? "text-secondaryblack"
                            : "text-secondaryblack "
                        }`}
                      >
                        {item.label}
                      </p>
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* end */}

          <div className="flex flex-col w-full  justify-between lg:hidden md:hidden pt-10 -mb-[58px]  w-screen -ml-[24px]">
            {data.map((section, idx) => (
              <div
                className={`flex flex-col w-auto  ${data.length-1!==idx?"border-b-[1px] border-journyborder":"pb-2"} `}
                key={idx}
              >
                <div className="flex flex-col w-full px-6">
                  <button
                    onClick={() => mobtoggle(idx)}
                    className={` py-3 pr-3 ${
                      section.path === url[1]
                        ? " text-base font-semibold navbtnafterclick mobile-toggle-button flex items-center gap-4 pr-2 w-full justify-between hover:text-highlight"
                        : "text-primarycolor  font-semibold justify-between text-base navbtnafter pr-2 flex items-center gap-4"
                    } ${
                      idx == mobiletoggle
                        ? "bg-irisblue p-6  w-screen -ml-6 text-white"
                        : " w-full"
                    } `}
                  >
                    {section.title}
                    <Icon
                      className={`menuarrow mt-1  ${
                        idx === mobiletoggle
                          ? "text-white rotate-180 mr-[24px]"
                          : "text-primarycolor"
                      }`}
                    />
                  </button>
                  {idx === mobiletoggle && (
                    <div className="flex flex-col gap-6 my-6 text-secondaryblack text-16">
                      {section.items.map((item, i) => (
                        <div
                          key={i}
                          className="flex gap-3 items-center hover:text-highlight"
                        >
                          {item.icon !== "" &&
                          item?.icon &&
                          section?.title !== "Products" ? (
                            <div className="w-[20px] h-[20px]">
                              <img
                                src={process.env.PUBLIC_URL + item.icon}
                                alt="icon"
                                className="w-[20px] h-[20px] "
                              ></img>
                            </div>
                          ) : (
                            <></>
                          )}
                          <Link
                            to={item.path}
                            key={i}
                            target={item.target ? "_blank" : "_self"}
                          >
                            <p className="hover-underline-animation text-secondaryblack text-16">
                              {item.label}
                            </p>
                          </Link>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="px-6 md:px-10 lg:px-20  py-5 font-normal border-t-[1px] border-EDF1FF flex text-secondaryblack relative">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:gap-12 w-full relative justify-between">
            <p className="text-16 lg:text-base">
              {window.innerWidth < 500
                ? `© 2025 by Transforma. All Right Reserved.`
                : `Copyright 2002 – ${year} by Transforma. All Rights Reserved.`}
            </p>
            <div className="flex text-16 text-secondaryblack lg:text-base font-normal gap-4 ">
              <Link
                to={"/disclaimer"}
                className="text-16 text-secondaryblack hover:text-ctaorange no-underline"
              >
                <p className="hover-underline-animation ">Disclaimer</p>
              </Link>
              <Link
                to={"company/sample/Composition"}
                className="text-16 text-secondaryblack hover:text-ctaorange no-underline"
              >
                <p className="hover-underline-animation">Samples</p>
              </Link>
              <a
                href={
                  process.env.PUBLIC_URL + "/codeofethics/Code of Ethics.pdf"
                }
                download
                className="hover-underline-animation text-16 text-secondaryblack hover:text-ctaorange no-underline"
              >
                Code of Ethics
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
